import { useEffect, useContext, useState } from "react";
import { UserContext } from "../../../contexts/UserContext";
import { setTitle } from "../../../assorted/setTitle";
import strings from "../../../i18n/definitions";
import { PageTitle } from "../../../components/PageTitle";
import SettingsItem from "../SharedComponents/SettingsItem";
import SettingsItemButton from "../SharedComponents/SettingsItemButton";
import ListOfSettingsItems from "../SharedComponents/ListOfSettingsItems";
import LogOutButton from "../LogOut/LogOutButton";
import ButtonContainer from "../../_pages_shared/ButtonContainer.sc";
import UpgradeAccountModal from "../../../components/UpgradeAccountModal";
import LocalStorage from "../../../assorted/LocalStorage";
import { APP_VERSION } from "../../../appVersion";
import DarkModeToggle from "../ThemeToggle/DarkModeToggle";

import * as s from "./Settings.sc";

export default function Settings() {
  const { userDetails } = useContext(UserContext);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    setTitle(strings.settings);
  }, []);

  const isAnonymous = userDetails?.is_anonymous;

  function handleUpgradeSuccess() {}

  return (
    <s.StyledWrapper>
      <PageTitle>{strings.settings}</PageTitle>

      {isAnonymous && (
        <ListOfSettingsItems header="Guest Account">
          <SettingsItemButton onClick={() => setShowUpgradeModal(true)}>
            Create Account to Save Progress
          </SettingsItemButton>
        </ListOfSettingsItems>
      )}

      <UpgradeAccountModal
        open={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        onSuccess={handleUpgradeSuccess}
        triggerReason="settings"
        bookmarkCount={userDetails?.bookmark_count || 0}
      />

      <ListOfSettingsItems header={isAnonymous ? "Language" : strings.myAccount}>
        {!isAnonymous && (
          <SettingsItem path={"/account_settings/profile_details"} state={{ from: "/account_settings" }}>
            {strings.profileDetails}
          </SettingsItem>
        )}
        <SettingsItem path={"/account_settings/language_settings"}>{strings.languageSettings}</SettingsItem>

        {!isAnonymous && <SettingsItem path={"/account_settings/my_classrooms"}>{strings.myClassrooms}</SettingsItem>}
      </ListOfSettingsItems>

      <ListOfSettingsItems header={"Feed preferences"}>
        <SettingsItem path={"/account_settings/interests"}>Interests</SettingsItem>
        <SettingsItem path={"/account_settings/feed_view"}>View</SettingsItem>
      </ListOfSettingsItems>

      {!isAnonymous && (
        <ListOfSettingsItems header={"Notifications"}>
          <SettingsItem path={"/account_settings/notifications"}>Email notifications</SettingsItem>
        </ListOfSettingsItems>
      )}

      <ListOfSettingsItems header={strings.exercises}>
        <SettingsItem path={"/account_settings/exercise_types"}>Audio & Pronunciation</SettingsItem>
        <SettingsItem path={"/account_settings/exercise_scheduling"}>Scheduling</SettingsItem>
      </ListOfSettingsItems>

      <ListOfSettingsItems header={"Display"}>
        <SettingsItem path={"/account_settings/display"}>Activity Timer</SettingsItem>
        <DarkModeToggle />
      </ListOfSettingsItems>

      {!isAnonymous && (
        <ListOfSettingsItems header={strings.accountManagement}>
          <SettingsItem path={"/account_settings/delete_account"}>{strings.deleteAccount}</SettingsItem>
        </ListOfSettingsItems>
      )}

      <ListOfSettingsItems header={"Developer"}>
        <SettingsItem path={"/account_settings/developer"}>Developer tools</SettingsItem>
      </ListOfSettingsItems>

      <ButtonContainer className={"adaptive-alignment-horizontal"} style={{ marginTop: "1em", marginBottom: "1em" }}>
        <LogOutButton />
      </ButtonContainer>

      <s.Version>v{APP_VERSION}</s.Version>
    </s.StyledWrapper>
  );
}
